module.exports = __webpack_public_path__ + "img/s2-img5.8e7f8ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lifeHome/s2-img5.png
// module id = 411
// module chunks = 0